import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client";
import { User } from "../types";

export const GET_CREATOR = gql`
  query GetCreator($username: String!) {
    creator(username: $username) {
      id
      username
      firstName
      fullname
      profileUrl
      coverUrl
      bannerUrl
      bio
      content
      creatorSubscriptions(platform: "stripe") {
        planId
        planType
        priceDetails {
          price
          currency
        }
      }
      links {
        id
        name
        link
        description
        imageUrl
        position
      }
      programs {
        name
        imageUrl
      }
    }
  }
`;

export function useCreator(username?: string) {
  const { data, loading, refetch, error } = useQuery(GET_CREATOR, {
    variables: { username },
  });
  console.log("error", error);
  const creator: User = data?.creator;
  return { creator, loading, refetch, error };
}
